export const NOT_ASSIGN_ITEM = {
  value: -1,
  label: 'Не задано',
};
